// Components==============
import storeInterest from 'actions/training/interest';
import Button from 'components/UI/Button';
import { TextInput } from 'components/UI/Form/Input';
import Modal from 'components/UI/Modal';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useCloseUrlModal } from 'utilities/useCloseUrlModal';
import { useFormValues } from 'utilities/useFormValues';
import './index.module.scss';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
// =========================

export default function InterestModal({
    training,
    isSchoolsTrainingPage,
    training_url,
    basePath = 'groei',
}) {
    const [displayMessage, setDisplayMessage] = useState('');
    const [mailConfirm, setMailConfirm] = useState('');

    const { formValues, handleChange } = useFormValues(
        {
            first_name: '',
            tussenvoegsel: '',
            last_name: '',
            email: '',
            school: '',
            position: '',
        },
        () => setDisplayMessage('')
    );

    const {
        first_name,
        last_name,
        tussenvoegsel,
        email,
        school,
        position,
    } = formValues;

    const dispatch = useDispatch();
    const closeUrlModal = useCloseUrlModal();

    const { pathname } = useLocation();

    const [confirmModalIsOpen, setConfirmModalIsOpen] = useState(false);

    function handleSubmit(e) {
        e.preventDefault();

        if (email !== mailConfirm)
            return setDisplayMessage('De email adressen komen niet overeen');

        if (!school)
            return setDisplayMessage('Je hebt nog geen school ingevoerd');

        dispatch(
            storeInterest({
                ...formValues,
                id: training?.id,
            })
        )
            .then(() => {
                setConfirmModalIsOpen(true);
            })
            .catch(() =>
                setDisplayMessage('Er ging iets mis met de aanmelding')
            );
    }

    useEffect(() => {
        setConfirmModalIsOpen(false);
    }, [pathname]);

    const slug = isSchoolsTrainingPage
        ? `/school-aanbod/${training_url}/training-popup/${training?.id}/interesse`
        : `/${basePath}/training-popup/${training?.id}/interesse`;

    return (
        <Modal slug={slug}>
            {!confirmModalIsOpen ? (
                <div styleName="content">
                    <h2>Interesseformulier</h2>
                    <form onSubmit={handleSubmit}>
                        <div styleName="column">
                            <div>
                                <TextInput
                                    label="Voornaam*"
                                    name="first_name"
                                    value={first_name}
                                    onChange={handleChange}
                                />
                            </div>
                            <div>
                                <TextInput
                                    label="Tussenvoegsel"
                                    required={false}
                                    name="tussenvoegsel"
                                    value={tussenvoegsel}
                                    onChange={handleChange}
                                />
                            </div>
                            <div>
                                <TextInput
                                    label="Achternaam*"
                                    name="last_name"
                                    value={last_name}
                                    onChange={handleChange}
                                />
                            </div>
                            <div>
                                <TextInput
                                    label="E-mail* (WERK E-MAIL VAN JE SCHOOL)"
                                    name="email"
                                    type="email"
                                    value={email}
                                    onChange={handleChange}
                                />
                            </div>
                            <div>
                                <TextInput
                                    label="E-email bevestiging* (WERK E-MAIL VAN JE SCHOOL)"
                                    name="mailConfirm"
                                    type="email"
                                    value={mailConfirm}
                                    onChange={(e) => {
                                        setDisplayMessage('');
                                        setMailConfirm(e.target.value);
                                    }}
                                />
                            </div>
                            <div>
                                <TextInput
                                    label="Functie en afdeling*"
                                    name="position"
                                    value={position}
                                    onChange={handleChange}
                                />
                            </div>
                        </div>
                        <div styleName="column">
                            <div>
                                <TextInput
                                    label="School*"
                                    name="school"
                                    value={school}
                                    onChange={handleChange}
                                />
                            </div>
                        </div>
                        <div styleName="bottom">
                            {displayMessage && (
                                <p styleName="error">{displayMessage}</p>
                            )}
                            <div>
                                <Button>Verzenden</Button>
                            </div>
                        </div>
                    </form>
                </div>
            ) : (
                <div styleName="confirm">
                    <h2>Bedankt voor je interesse!</h2>
                    <p>
                        We hebben je interesse in {training?.name} in ontvangst
                        genomen. Controleer je mailbox, hierin heb je een
                        bevestiging gekregen van je interesse in{' '}
                        {training?.name}.
                    </p>
                    <Button onClick={closeUrlModal}>
                        Terug naar overzicht
                    </Button>
                </div>
            )}
        </Modal>
    );
}
